import { cssVar } from '@toeverything/theme';

export const EmptyWorkspaceNotice = ({
  authenticated,
  workspaceCount,
  loading,
}: {
  authenticated: boolean;
  workspaceCount: number;
  loading: boolean;
}) => {
  if (!authenticated || loading || workspaceCount > 0) {
    return null;
  }

  return (
    <div
      role="status"
      style={{
        margin: '4px 8px 12px',
        color: cssVar('textSecondaryColor'),
        fontSize: cssVar('fontXs'),
        lineHeight: '20px',
      }}
    >
      <strong
        style={{
          display: 'block',
          marginBottom: 4,
          color: cssVar('textPrimaryColor'),
          fontWeight: 600,
        }}
      >
        Nenhum espaço disponível para esta conta
      </strong>
      Para acessar um espaço compartilhado, peça a um responsável por ele que
      convide esta conta.
    </div>
  );
};
